"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformNotificationResourceToJSON = exports.transformJSONToNotificationResource = void 0;

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformNotificationResourceToJSON = function transformNotificationResourceToJSON(value) {
  return {
    id: value.id,
    type: value.type,
    extra: value.extra
  };
};

exports.transformNotificationResourceToJSON = transformNotificationResourceToJSON;

var transformJSONToNotificationResource = function transformJSONToNotificationResource(value) {
  return {
    id: value.id,
    type: value.type,
    extra: value.extra
  };
};
/**
 * The main object that this notification is related. It contains the ID of the object along with its type and partial data. The content of this object varies between notification types.
 * @export
 * @interface NotificationResource
 */


exports.transformJSONToNotificationResource = transformJSONToNotificationResource;